/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import PropTypes from 'prop-types'

const ScheduleCampaignRoute = ({ component: Component, ...rest }) => (
  <Component {...rest} />
)

ScheduleCampaignRoute.propTypes = {
  component: PropTypes.func.isRequired,
}

export default ScheduleCampaignRoute
